import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  headings: {
    fontSize: '30px',
    fontWeight: 200,
  },
  reportSection: {
    border: 'none',
    borderRadius: '0',
    marginBottom: '16px',
    padding: '14px 18px',
  },
}));

const DashDetailsWrapper = ({ backgroundColor, expandColor, heading1, heading2, children, overflowX }) => {
  const classes = useStyles();
  const location = useLocation();
  const [expanded, setExpanded] = useState(true);
  const isReportExport = location.pathname.includes('/report-export/');

  if (isReportExport) {
    return (
      <Box data-page-break="true" className={classes.reportSection}>
        <Box display="flex" alignItems="center" width="100%" marginBottom="8px" flexWrap="wrap" gridGap="12px">
          <Typography variant="h4" className={classes.headings} style={{ color: '#19989B' }}>
            {heading1.text}
          </Typography>
        </Box>
        <Box>{children}</Box>
      </Box>
    );
  }

  return (
    <Box style={{ backgroundColor, overflowX: overflowX ? 'scroll' : 'unset' }}>
      <Accordion
        style={{ padding: '10px 15px', backgroundColor: 'transparent' }}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}>
        <AccordionSummary expandIcon={<ExpandMore fontSize="large" style={{ color: expandColor }} />}>
          <Box display="flex" alignItems="center" width="95%">
            <Typography variant="h4" className={classes.headings} style={{ color: heading1.color }}>
              {heading1.text}
            </Typography>
            {heading2 && (
              <Typography variant="h4" className={classes.headings} style={{ color: heading2.color, marginLeft: '32%' }}>
                {heading2.text}
              </Typography>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default DashDetailsWrapper;
